module.exports = __webpack_public_path__ + "img/banner-2.cf8682f1.png";